/**
 * Shared constants for sensor-device lists (PD-13926).
 *
 * PD-15562: the badge renders `healthState`, not the raw `status` column.
 * `healthState` folds `lastSeen` staleness and the unit's placement into the
 * stored status, which adds one value the stored enum does not have: `idle`.
 * A stale unit sitting at a warehouse is expected — units are bench-validated
 * and then unplugged there — so it reads neutral rather than red, and only a
 * stale unit at a customer placement is reported as Offline.
 */
export const SENSOR_DEVICE_STATUS_VALUE_MAPPING = [
	{
		value: 'online',
		label: 'Online',
		color: { type: 'success' },
	},
	{
		value: 'idle',
		label: 'Idle',
		color: { type: 'neutral' },
	},
	{
		value: 'offline',
		label: 'Offline',
		color: { type: 'danger' },
	},
	{
		value: 'error',
		label: 'Error',
		color: { type: 'danger' },
	},
	{
		value: 'maintenance',
		label: 'Maintenance',
		color: { type: 'warning' },
	},
];
